import { render } from "./DbSubscribePropsCmp.vue?vue&type=template&id=120c2202"
import script from "./DbSubscribePropsCmp.vue?vue&type=script&lang=js"
export * from "./DbSubscribePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__